





















import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {CustomerApi} from "@swagger";

@Component({
  components: {}
})
export default class NewsletterUnsubscribe extends BasicComponent {

  loading: boolean = true;
  success: boolean = false;
  error: boolean = false;

  get token() {
    return this.$route.params["token"];
  }

  created() {
    new CustomerApi(this.apiConfiguration).unregisterCustomer(this.token).then(() => {
      this.success = true;
      this.loading = false;
    }).catch((err) => {
      err.json().then(error => {
        this.error = error;
        this.loading = false;
      });
    });
  }

  mounted() {
    this.trackPage("Newsletter Abmeldung");
  }
}

